export default __webpack_public_path__ + "static/media/dz.8ec59ccb.svg";